import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { MenuCollapseItemComponent } from '../../menu-collapse-item/menu-collapse-item.component';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { CollapsibleDirective } from '../../../directives/collapsibleDirective.directive';
import { NavigationItem } from '../../../interfaces/navigationList.interface';
import { MenuTool } from '../../../interfaces/MenuTool.interface';
import { PageContainerService } from '../../../services/page-container.service';

@Component({
    selector: 'st-menu-drawer-section-content',
    imports: [CommonModule, MenuCollapseItemComponent, CollapsibleDirective],
    templateUrl: './menu-drawer-section-content.component.html',
    styleUrls: ['./menu-drawer-section-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuDrawerSectionContentComponent {
  navigationItem = input<NavigationItem | null>();
  tools = input<MenuTool[] | null>();
  hideContent = output<boolean>();

  activeChild = signal<NavigationItem | null>(null);

  navigationItem$ = this.pageContainerService.activeSectionRoute.pipe(
    tap(nav => {
      if (nav?.children.length) {
        this.setActiveItem(nav);
      } else {
        this.activeChild.set(null);
      }
    }),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {}

  back() {
    this.hideContent.emit(true);
  }

  openTool(url: string) {
    window.open(url, '_blank');
  }

  setActiveItem(nav: NavigationItem | null) {
    if (!nav) {
      return;
    }
    let currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url.split('?')[0])?.routePath;

    const index = nav.children.findIndex(
      y => y && currentPath && y.id === currentPath[1],
    );
    if (index === -1) {
      return;
    }
    this.activeChild.set(nav.children[index]);
  }
}
